const doc = [({"no":({"js":({"components":({"app_layout":({"menu":({"notification_settings":"Notifikationsinnstillinger"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;